<template>
  <!-- <div style="position: fixed; bottom: 0; z-index: 666"> -->
  <div>
    <div class="foot_top">
      <div class="foot_top_in container">
        <div
          class="nav"
          v-for="(nav, index) in footNav"
          :key="index"
          @click="toPage(nav)"
        >
          <span class="name"> {{ nav.name }}</span>
        </div>
      </div>
    </div>
    <footer class="mobile-footer">
      <div class="footer-content">
        <div class="footer-img">
          <div class="img_con" v-for="(icon, index) in imgIcon" :key="index">
            <div v-html="icon"></div>
          </div>
        </div>
        <!-- <div class="footer-img">
          <div class="img_con" v-for="(icon, index) in imgIcon" :key="index">
            <img :src="icon" />
          </div>
        </div> -->

        <div class="footer-section">
          <div
            class="footer-column"
            v-for="(column, index) in footerColumns"
            :key="index"
          >
            <h3>{{ column.title }}</h3>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getColumnAll } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  data() {
    return {
      // isMobile: false,
      currentYear: new Date().getFullYear(),
      footNav: [
        { name: '新闻资讯', path: '' },
        { name: '交通信息', path: '' },
        { name: '剧场介绍', path: '' },
        { name: '纪念品', path: '' },
      ],
      imgIcon: [
        require('@/assets/img/appImg/foot_icon1.png'),
        require('@/assets/img/appImg/foot_icon2.png'),
        require('@/assets/img/appImg/foot_icon3.png'),
        require('@/assets/img/appImg/foot_icon4.png'),
        require('@/assets/img/appImg/foot_icon5.png'),
        require('@/assets/img/appImg/foot_icon6.png'),
        require('@/assets/img/appImg/foot_icon7.png'),
        require('@/assets/img/appImg/foot_icon8.png'),
      ],
      footerColumns: [
        {
          title: '联系我们',
        },
        {
          title: '友情链接',
        },
      ],
      cloumnList: [],
      detail: {},
    };
  },
  mounted() {
    this.cloumnList = this.$store.state.navTree;
    this.getColumnList();
    this.getFoot();
  },
  methods: {
    getColumnList() {
      const navObj = getColumnAll();
      this.footNav = navObj.footNav;
    },
    toPage(nav) {
      this.$router.push({
        path: nav.accessPath,
        query: { cloumnId: nav.id },
      });
    },
    getFoot() {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/foot') {
          id = c.id;
        }
      });

      getPageObj(id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
          this.footerColumns.map((f, index) => {
            if (index == 0) {
              f.title = this.$t('contactUs');
            }
            if (index == 1) {
              f.title = this.$t('supportUs');
            }
          });
          this.imgIcon = this.setFootImg(this.detail['contact3']).img;
        }
      });
    },
    setFootImg(htmlString) {
      // 创建一个临时DOM元素
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // 获取所有p元素
      const pElements = tempDiv.querySelectorAll('p');

      // 第一个p元素是文本
      const textPart = pElements[0].outerHTML; // <p>@乌镇戏剧节</p>

      // 剩下的p元素是图片
      let imageParts = [];
      for (let i = 1; i < pElements.length; i++) {
        if (pElements[i].outerHTML.includes('img')) {
          imageParts.push(pElements[i].outerHTML);
        }
      }
      const imagePart = imageParts.join(''); // 合并所有图片p标签
      return { img: imageParts, text: textPart };
    },
  },

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.foot_top {
  background: linear-gradient(90deg, #aae5ef 0%, #b1bbff 100%);
  height: 4rem;
  line-height: 4rem;
  display: flex;
  align-items: center;
  .foot_top_in {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .nav {
    font-size: 1.125rem;
    color: #333333;
    font-family: SourceHanSansCN-Medium;
    padding: 0 1.8rem; /* 左右内边距 */
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;

    .name {
      flex: 1;
      text-align: center; /* 文字改为居中 */
    }
  }
  .nav:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 16px;
    background: #333;
  }
}
footer {
  background-color: #424451;
  color: #ecf0f1;
  padding: 2rem 0 0;
  margin-top: auto;
  overflow: hidden;
  .line {
    display: inline-block;
    width: 100%;
    height: 1px;
    background: #ffffff;
    margin: 0 1.5rem 1.5rem;
  }
}

.footer-content {
  margin: 0 auto;
  padding: 0 1.5rem;
  .footer-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .img_con {
      // flex: 25%; /* 4个/行，减去间隙 */
      // box-sizing: border-box;

      img {
        width: 3rem;
        height: 3rem;
        // margin-right: 1.25rem;
        margin-bottom: 0.75rem;
      }
    }
  }
  .footer-section {
    padding: 0 1rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;

    .footer-column {
      h3 {
        margin-bottom: 1.5rem;
        font-size: 1.1667rem;
        text-align: left;
        font-family: SourceHanSansCN-Medium;
      }
    }
  }
}

/* 移动端样式 */
.mobile-footer .footer-content {
  flex-direction: column;
  margin: 0 1.5rem;
}

.mobile-footer .footer-section {
  padding: 0;
  margin: 0.625rem 0 1.5rem;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: row;
  }

  .footer-section {
    padding: 0;
    margin-bottom: 1.5rem;
  }
}
</style>
